import { Injectable } from '@angular/core';

@Injectable()
export class RolesAccessData {
    staticData = {
        'admin': {
            'associate' : {
                '/home/associate/feed': {
                    label: 'Timeline Screen',
                    value: true
                }
            }
        }
    };
};
